import { createTeleporter } from 'react-teleporter';

export const Footer = createTeleporter();
export const Header = createTeleporter();
